import Pusher from "pusher-js";
import Cookies from "js-cookie";
import axios from "axios";

const PUSHER_KEY = "e8ced23f17a46bf9d477";

export class ApiClient {
  constructor(authPayload, pusherConfig) {
    Pusher.logToConsole = true;
    Cookies.set("telegram", authPayload.telegram);
    this.telegramLogin().then(() => {
      this._authPayload = authPayload;
      this._pusher = new Pusher(PUSHER_KEY, pusherConfig);
      this._privateChannel = this._pusher.subscribe("private-channel");
      this._publicChannel = this._pusher.subscribe("public-channel");
      this._privateChannel.bind("pusher:subscription_succeeded", () => {});
    });
  }

  on(event, callback, { privateChannel = true }) {
    privateChannel && this._privateChannel.bind(event, callback);
    !privateChannel && this._publicChannel.bind(event, callback);
    return this;
  }

  telegramLogin() {
    return axios.get("/api/auth").then(() => {});
  }

  fetchSlots() {
    return axios.get("/api/slots", { ...this._authPayload });
  }

  static WithTelegramAuth({ authEndpoint, payload }) {
    const authPayload = {
      telegram: JSON.stringify(payload)
    };

    const pusherConfig = {
      cluster: "eu",
      forceTLS: true,
      authEndpoint,
      auth: {
        params: {
          ...authPayload
        }
      }
    };

    return new ApiClient(authPayload, pusherConfig);
  }
}
